import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IRemovePromoCodeActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/PromoCodeActionParams";
import { updateBookingPromoCodes } from "./promoCodeHelper";

export class RemovePromoCodeAction extends BaseAction<string, IRemovePromoCodeActionParams> {
    override async run(): Promise<string> {
        try {
            const { bookingId, promoCode } = this.params!;
            if (!bookingId) {
                return "";
            }
            const remaining = (getRecoilStateValue<string[]>("listOfAppliedPromoCodeAtom", []) || [])
                .filter(c => c !== promoCode);
            const booking = await updateBookingPromoCodes(bookingId, remaining);
            // PATCH bookings raises no toast, so the inline message is the only feedback.
            updateRecoilState("promoCodeErrorAtom", booking ? "" : "apiErrorMsg");
        } catch (error) {
            console.error("Error removing promo code", error);
            updateRecoilState("promoCodeErrorAtom", "apiErrorMsg");
        } finally {
            return "";
        }
    }
}

export const removePromoCodeAction = new RemovePromoCodeAction();
